import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import React from "react";

export function DotsSizeSelector(props: { setDotSize: (multiplier: number) => void }) {
  return (
    <Box className="horizontal-flex flex-wrap">
      <Typography>Positions dot size:&nbsp;</Typography>
      <ButtonGroup variant="outlined" aria-label="outlined primary button group">
        <Button onClick={() => props.setDotSize(1)}>Small</Button>
        <Button onClick={() => props.setDotSize(4)}>Medium</Button>
        <Button onClick={() => props.setDotSize(16)}>Large</Button>
      </ButtonGroup>
    </Box>
  );
}
